import { useEffect, useState } from "react";
import { Permissions } from "@repo/database";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { z } from "zod";

import { SettingsHeader } from "~/components/layout/settings-header";
import { Button } from "~/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "~/components/ui/form";
import { Input } from "~/components/ui/input";
import { api } from "~/lib/api";
import { usePermissionManager } from "~/managers/use-permission-manager";
import { usePermissionStore } from "~/stores/use-permission-store";

export const Route = createFileRoute("/_main/settings/_layout/account/")({
  component: BillingPage,
});

function BillingPage() {
  const { hasPermission } = usePermissionManager();
  const { currentEmployee } = usePermissionStore();

  const [permission, setPermission] = useState(false);
  const { t } = useTranslation("common");
  const form = useForm({
    schema: z.object({
      password: z.string(),
    }),
    defaultValues: {
      password: "",
    },
  });

  const { mutate: updatePassword } = api.user.updatePassword.useMutation({
    onSuccess: () => {
      toast.success("Password updated");
      void form.reset();
    },
  });

  const handleSubmit = form.handleSubmit((data) => {
    updatePassword(data.password);
  });

  useEffect(() => {
    if (!currentEmployee) {
      setPermission(false);
    }
    hasPermission({
      requiredPermission: Permissions.delete_order,
      label: "Enter PIN to view account settings.",
    })
      .then((result) => {
        setPermission(result.permission);
      })
      .catch((e) => console.error(e));
  }, [hasPermission, currentEmployee, t]);

  if (!permission) return null;
  return (
    <>
      <SettingsHeader title={t("Account.page_title")} />
      <Form {...form}>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Card>
            <CardHeader>
              <CardTitle>{t("Company.general_title")}</CardTitle>
              <CardDescription></CardDescription>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-4">
              <FormField
                control={form.control}
                name="password"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Password</FormLabel>
                    <Input type="password" {...field} />
                  </FormItem>
                )}
              />
            </CardContent>
            <CardFooter>
              <Button type="submit" variant="success">
                Save
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </>
  );
}
